import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogout } from './Auth.hooks';
import { AppContext } from '../../../App.context';
import { getApolloClient } from '../../../views/home/auth/Authentication.hooks';

export function Logout() {
	const { setApolloClient, kv } = useContext(AppContext);
	const navigate = useNavigate();
	const isLoading = useLogout();
	useEffect(() => {
		if (!isLoading) {
			setApolloClient(getApolloClient());
			kv.clear();
			navigate('/');
			navigate(0);
		}
	}, [isLoading]);
	return <div>Loading</div>;
}
